// Game-report reasons — shared by the client report form (select options),
// the server intake (validation), and the admin inbox (labels). Keep this the
// single source of truth so the three surfaces never drift.
//
// `value` is the stored enum; `label` is what users/admins see. Order is the
// display order in the dropdown. The default selection is `not_working`.

export const GAME_REPORT_REASONS = [
  { value: 'not_working',      label: "Not working / won't load" },
  { value: 'missing',          label: 'Game or content missing' },
  { value: 'wrong_score',      label: 'High score is incorrect' },
  { value: 'wrong_achievement', label: 'Achievement unlock is wrong' },
  { value: 'wrong_metadata',   label: 'Wrong title / artwork / metadata' },
  { value: 'inappropriate',    label: 'Inappropriate content' },
  { value: 'other',            label: 'Other' },
];

export const DEFAULT_GAME_REPORT_REASON = 'not_working';

export const GAME_REPORT_REASON_VALUES = new Set(GAME_REPORT_REASONS.map(r => r.value));

export const GAME_REPORT_REASON_LABELS = Object.fromEntries(
  GAME_REPORT_REASONS.map(r => [r.value, r.label]),
);
